module.exports = __webpack_public_path__ + "f706d91961949d2461b197709aa2abbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/neu/sozialhilfebeziehende-neu.svg
// module id = 134
// module chunks = 1